<template>
	<div class="display-flex flex-column">
		<div class="title-container">{{ title }}</div>
		<div class="back-to-menu flex-row flex-start--center mt-5">
			<v-btn v-if="!noBackButton" @click="showSelectAppScreen" class="back-button" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</v-btn>
			{{ selectedApp.service_name }}
		</div>
		<AppActionSearchField
			v-model="localSearchString"
			:placeholder="`Search ${isTrigger ? 'triggers' : 'actions'} in ${selectedApp.service_name}`"
			:loading="loading"
		/>
	</div>
</template>

<script>
import AppActionSearchField from '../AddNewStep/AppActionSearchField';

export default {
	name: 'IntegrationTitle',
	props: {
		loading: { type: Boolean },
		searchString: { type: String },
		title: { type: String, default: 'Choose action' },
		noBackButton: { type: Boolean },
		isTrigger: { type: Boolean },
		selectedApp: { type: Object, required: true },
	},
	components: { AppActionSearchField },
	computed: {
		localSearchString: {
			set(value) {
				this.$emit('update:searchString', value);
			},
			get() {
				return this.searchString;
			},
		},
	},
	methods: {
		showSelectAppScreen() {
			this.$emit('showSelectAppScreen');
		},
	},
};
</script>

<style scoped lang="scss">
.title-container {
	font-size: 16px;
	font-weight: bold;
	background: transparent;
	color: var(--bold-title);
}
.back-to-menu {
	width: 100%;
	font-size: 14px;
	font-weight: normal;

	.back-button {
		margin-right: 5px;
		border-radius: 6px;
		border: 1px solid var(--grey-background);
	}
}
</style>
